import {CopyToClipboardIconButton} from '@github-ui/copy-to-clipboard/IconButton'
import {getHeadBranchText} from '../utils/branch-label'
import {PullRequestBranchName} from './PullRequestBranchName'
import {useIsFeatureStateEnabled} from '../hooks/use-feature-state'

export interface PullRequestHeadBranchNameProps {
  baseRepositoryOwnerLogin: string
  headBranch: string
  headRepositoryOwnerLogin?: string
  headRepositoryName?: string
  isInAdvisoryRepo?: boolean
}

/** Displays the clipboard-copyable head branch name of a pull request. */
export function PullRequestHeadBranchName({
  baseRepositoryOwnerLogin,
  headBranch,
  headRepositoryOwnerLogin = '',
  headRepositoryName = '',
  isInAdvisoryRepo,
}: PullRequestHeadBranchNameProps) {
  const showUpdatedHeader = useIsFeatureStateEnabled('overview')

  const text = getHeadBranchText(
    baseRepositoryOwnerLogin,
    headRepositoryOwnerLogin,
    headRepositoryName,
    headBranch,
    isInAdvisoryRepo,
  )

  return showUpdatedHeader ? (
    <PullRequestBranchName
      branch={headBranch}
      branchText={text}
      repositoryName={headRepositoryName}
      repositoryOwner={headRepositoryOwnerLogin}
      button={
        <CopyToClipboardIconButton
          ariaLabel="Copy head branch name to clipboard"
          size="small"
          textToCopy={headRepositoryOwnerLogin ? text : headBranch}
        />
      }
    />
  ) : (
    <div className="d-flex flex-items-center overflow-hidden gap-1">
      <PullRequestBranchName
        branch={headBranch}
        branchText={text}
        repositoryName={headRepositoryName}
        repositoryOwner={headRepositoryOwnerLogin}
      />
      <CopyToClipboardIconButton
        ariaLabel="Copy head branch name to clipboard"
        size="small"
        textToCopy={headRepositoryOwnerLogin ? text : headBranch}
      />
    </div>
  )
}
